export default __webpack_public_path__ + "static/media/sidebar-arrows.675b655c.svg";